import { requests } from '../../api/api.service';
import { ONBOARDING_URL } from '../../utils/Endpoints';

export const OnboardingService = {
    getAllRequests: (params: any) => requests.get(`${ONBOARDING_URL}/requested`, params),
    updateIsContacted: (id: number) => requests.put(`${ONBOARDING_URL}/requests/contact/toggle/${id}`, {}),
    updateIsDeclined: (id: number) => requests.put(`${ONBOARDING_URL}/requests/declined/toggle/${id}`, {}),
    updateEmail: (id: number, body: { email: string }) => requests.put(`${ONBOARDING_URL}/email/change/${id}`, body),
};
